import { useModel as _useModel, useCssVars as _useCssVars, unref as _unref, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "range-slider" }
const _hoisted_2 = ["step", "min", "max"]

import { computed } from 'vue';

type Props = {
	min?: number;
	max?: number;
	step?: number;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'RangeSliderNew',
  props: /*@__PURE__*/_mergeModels({
    min: { default: 0 },
    max: { default: 100 },
    step: { default: 1 }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

_useCssVars(_ctx => ({
  "3669dfbc": (trackWidth.value)
}))

const props = __props;
const model = _useModel<number>(__props, "modelValue");

const trackWidth = computed(() => {
	if (!model.value) {
		return 0;
	}
	return `${(100 / (props.max - props.min)) * (model.value - props.min)}%`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "range-slider__range-track" }, null, -1 /* HOISTED */)),
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
      type: "range",
      step: _ctx.step,
      min: _ctx.min,
      max: _ctx.max
    }, null, 8 /* PROPS */, _hoisted_2), [
      [
        _vModelText,
        model.value,
        void 0,
        { number: true }
      ]
    ])
  ]))
}
}

})